import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React from "react";
import styles from "./Photos.module.scss";
import ShowIf from "../../ShowIf/ShowIfView";
import DraggablePhoto from "../DraggablePhoto/DraggablePhotoContainer";
import TimelinePhoto from "../../TimelinePhoto/TimelinePhotoView";
import i18n from "../../../constants/i18n";

export function SortablePhoto({
    photo,
    ceremonyId,
    showPhotoAdjustmentModal,
    deletePhoto,
    positionIndex,
    blockImages,
}) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: photo.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    const isBlockImage = blockImages.includes(photo.id);

    return (
        <div ref={setNodeRef} style={style}>
            <div className={styles.editButtonContainer}>
                <ShowIf condition={isBlockImage}>
                    <span
                        className={`icon is-small ${styles.blockImageCheck}`}
                        title={i18n.photos.isBlockImage}
                    >
                        <i className="fas fa-check"></i>
                    </span>
                </ShowIf>
                <ShowIf condition={photo.fileName}>
                    <span
                        className={`icon is-small ${styles.deleteButton}`}
                        onClick={() =>
                            showPhotoAdjustmentModal(ceremonyId, photo.id)
                        }
                    >
                        <i className="fas fa-pen"></i>
                    </span>
                </ShowIf>
                <ShowIf condition={photo.fileName || photo.processingFailure}>
                    <span
                        className={`icon is-small ${styles.deleteButton}`}
                        onClick={() => deletePhoto(photo.id)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </span>
                </ShowIf>
            </div>
            <DraggablePhoto
                photo={photo}
                displayableIndex={positionIndex + 1}
                sortableAttributes={attributes}
                sortableListeners={listeners}
                render={({
                    snapshot,
                    placeholder,
                    selectionCount,
                    isSelected,
                    isGhosting,
                }) => (
                    <React.Fragment>
                        <TimelinePhoto
                            photo={photo}
                            isSelected={!snapshot.isDragging && isSelected}
                        />
                        <ShowIf
                            condition={
                                snapshot.isDragging && selectionCount > 1
                            }
                        >
                            <div className={styles.selectionCount}>
                                {selectionCount}
                            </div>
                        </ShowIf>
                    </React.Fragment>
                )}
            ></DraggablePhoto>
        </div>
    );
}
